/**
 * MidMarketEquity.jsx — Subtab XIV
 */

import React from "react";
import { TieredAccess } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function MidMarketEquity() {
  return (
    <article>
      <SubtabHeading roman="XIV">The Mid-Market Equity Solution</SubtabHeading>
      <TieredAccess />
      <GapBlock>
        AmLaw 100 firms can afford dedicated air-gapped infrastructure. Solo
        and small firms cannot, creating a two-tier confidentiality regime.
      </GapBlock>
      <SolutionLead>
        A tiered access model with shared infrastructure for smaller firms,
        structured to preserve the co-counsel framework's doctrinal integrity.
      </SolutionLead>
      <Body>
        <P>
          <strong>Tier 1</strong> (AmLaw 100, large boutiques) operates
          dedicated single-firm infrastructure as described throughout this
          offering.
        </P>
        <P>
          <strong>Tier 2</strong> (mid-market firms, sophisticated boutiques)
          operates on shared physical infrastructure with cryptographic and
          HSM-enforced isolation at the matter level — the same controls that
          protect ethical walls within a single firm extend to protect client
          firms from each other on shared hardware. The supervising attorney
          for each engagement remains a dedicated lawyer at CoConsoleX with
          that firm's matters as their sole assignment, preserving the
          lawyer-to-lawyer engagement structure.
        </P>
        <P>
          <strong>Tier 3</strong> (solo practitioners, small firms) operates
          on a referral basis where CoConsoleX provides specific AI-augmented
          work products (research memoranda, document review, draft analysis)
          on a per-task basis. This is structured as discrete co-counsel
          engagements per matter rather than ongoing infrastructure access,
          which fits the smaller firm's economics and regulatory profile.
        </P>
        <P>
          The pricing reflects the tiering. Tier 1 is dedicated infrastructure
          pricing (likely $500K–$2M annual run-rate per firm depending on
          usage). Tier 2 is shared infrastructure pricing (maybe $50K–$200K
          annually). Tier 3 is per-matter or per-hour pricing analogous to
          existing contract-attorney rates with an AI multiplier.
        </P>
        <P>
          This addresses the equity concern affirmatively rather than ignoring
          it, and it expands the addressable market significantly. CaseSignalHQ
          names this as a deliberate design choice of the standard, not a
          workaround. Doing so also positions CaseSignalHQ as concerned with
          access-to-justice issues, which is reputationally valuable.
        </P>
      </Body>
    </article>
  );
}
